<ng-container *ngIf="isLoading(); else contenido">
  <new-flowbanner [showPromo]="true"></new-flowbanner>
  <sura-loader></sura-loader>
</ng-container>

<ng-template #contenido>
  <div class="summary-page">
    <new-flowbanner [showPromo]="true"></new-flowbanner>

    <main class="summary-page-container">
      <div class="container-fluid p-0">
        <div class="summary-page__principal-row">
          <!-- Columna izquierda: detalle -->
          <div class="col-12 col-md-6">
            <div class="details-section">
              <div class="d-block d-md-none text-center">
                <h1 class="main-title m-2 m-md-1">Revisa y paga tu seguro</h1>
                <p class="color-subtitle">Confirma que todo esté correcto y elige cómo quieres pagar.</p>
              </div>

              <app-summary-plan-card
                class="col-md-10 mx-auto mt-4 mt-md-5"
                [planTitle]="planTitle()"
                [propertyAddress]="propertyAddress()"
                [city]="propertyCity()"
                [owner]="ownerInfo()"
                [coverages]="coverages()"
                [paymentType]="tipoPago()"
                [totalAmount]="valorAnual()"
                [monthlyAmount]="valorMes()"
              ></app-summary-plan-card>
            </div>
          </div>

          <!-- Columna derecha: pago -->
          <div class="col-12 col-md-6">
            <div class="payment-section" [ngClass]="{ 'month-payment': tipoPago() === 'Mensual' }">
              <div class="payment-content">
                <div class="d-none d-md-block text-start">
                  <h1 class="main-title m-2 m-md-1">Revisa y paga tu seguro</h1>
                  <p class="color-subtitle">Confirma que todo esté correcto y elige cómo quieres pagar.</p>
                </div>

                <app-policy-start-date class="d-block mt-3" [startDate]="contractStartDate()"></app-policy-start-date>

                <ng-container *ngIf="tipoPago() === 'Mensual'; else annualBlock">
                  <div class="payment-options-container mt-4">
                    <app-subscription-card
                      class="d-block"
                      [showSubscription]="true"
                      [isSelected]="selectedPaymentMethod() === 'subscription'"
                      [showPromo]="showPromo()"
                      [promoPoints]="promoPoints()"
                      [pointsPerAmount]="pointsPerAmount()"
                      [disabled]="isPaying()"
                      (payWithCard)="selectMethod('subscription')"
                    ></app-subscription-card>

                    <app-manual-payment-card
                      class="d-block mt-3"
                      [isSelected]="selectedPaymentMethod() === 'payment'"
                      [disabled]="isPaying()"
                      (payWithPSE)="selectMethod('payment')"
                    ></app-manual-payment-card>

                    <button
                      class="summary-page__pay-button d-none d-md-block mt-4"
                      type="button"
                      [disabled]="isPaying() || !selectedPaymentMethod()"
                      (click)="selectedPaymentMethod() && handlePayment(selectedPaymentMethod()!)"
                    >
                      <span *ngIf="!isPaying(); else procesando">Pagar</span>
                      <ng-template #procesando><span>Procesando…</span></ng-template>
                    </button>
                  </div>
                </ng-container>

                <ng-template #annualBlock>
                  <div class="w-100 d-flex justify-content-center mt-4 flex-column align-items-center">
                    <button
                      class="summary-page__pay-button d-none d-md-block mt-3"
                      type="button"
                      [disabled]="isPaying()"
                      (click)="handlePayment('payment')"
                    >
                      <span *ngIf="!isPaying(); else procesandoAnual">Pagar</span>
                      <ng-template #procesandoAnual><span>Procesando…</span></ng-template>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Barra móvil sticky -->
    <div class="mobile-payment-bar d-block d-md-none">
      <div class="mobile-payment-bar__row">
        <div class="mobile-payment-bar__text">
          <span class="mobile-payment-bar__title">Hoy pagas</span>
          <span *ngIf="tipoPago() === 'Mensual'" class="mobile-payment-bar__subtitle">
            Corresponde a tu primer mes
          </span>
          <span class="mobile-payment-bar__tax">IVA incluido</span>
        </div>
        <div class="mobile-payment-bar__price">${{ valorAPagar() | number: '1.0-0' }}</div>
      </div>

      <button
        class="mobile-payment-bar__button"
        type="button"
        [disabled]="isPaying() || (tipoPago() === 'Mensual' && !selectedPaymentMethod())"
        (click)="
          tipoPago() === 'Mensual'
            ? selectedPaymentMethod() && handlePayment(selectedPaymentMethod()!)
            : handlePayment('payment')
        "
      >
        <span *ngIf="!isPaying(); else procesandoMobile">Pagar</span>
        <ng-template #procesandoMobile><span>Procesando…</span></ng-template>
      </button>
    </div>
  </div>
</ng-template>
